'use client'

import React from 'react'
import Fab from '@mui/material/Fab'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import ScrollTop from '../src/components/basic/ScrollTop'
import ThemeRegistry from '../src/components/ThemeRegistry'

export default function Providers({
                                      children,
                                  }: {
    children: React.ReactNode;
}) {
    return (
        <ThemeRegistry>
            {children}
            <ScrollTop>
                <Fab color='secondary' size='small' aria-label='scroll back to top'>
                    <KeyboardArrowUpIcon />
                </Fab>
            </ScrollTop>
        </ThemeRegistry>
    )
}
